import { v2Request } from "helpers/request";

export const getDelegateCalendarAppointments = ({
  from,
  to,
}: {
  from: string;
  to: string;
}) => {
  return v2Request(`/appointments/delegate-calendar/${from}/${to}`);
};
